<template>
    <div class="panel result">
        <div class="row">
            <div class="float-left" id="identicon" style="display: none"></div>
            <div class="col">
              <div class="mb-4" v-for="(item) in batchAddresses" :key="item.address">
                <div style="margin-bottom: 6px;font-size: 16px;color: #5f5f5f;">
                  <span v-text="item.address"></span>,<span v-text="item.privKey"></span>
                </div>
<!--                -->
<!--                <div>Address: <span class="output" v-text="item.address"></span></div>-->
<!--                <div>Private key: <span class="output" v-text="item.privateKey"></span></div>-->
              </div>
            </div>
<!--            <div class="col-lg-2 col-12">-->
<!--                <button data-remodal-target="modal" class="save button-large" :disabled="!privateKey">-->
<!--                    <i class="icon-lock"></i>Save-->
<!--                </button>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    import * as blockies from 'blockies';

    export default {
        props: {
            address: String,
            privateKey: String,
            batchAddresses: Array,
        },
        data: function () {
            return {
                reveal: true,
            };
        },
        watch: {
            address(addr) {
                this.reveal = true;
                const id = document.getElementById('identicon');
                id.innerHTML = '';
                if (addr) {
                  id.appendChild(blockies({ seed: addr.toLocaleLowerCase(), scale: 6 }));
                }
            },
        },
        methods: {
            revealKey() {
                this.reveal = true;
            },
        },
    };
</script>

<style lang="sass" scoped>
    @import "../css/variables"
    #identicon
        width: 48px
        height: 48px
        margin: 0 15px
        background-color: $panel-background-alt

    .output
        font-family: $monospace-font
        color: $text-alt
        margin-left: 15px
        word-break: break-all
        font-size: 15px

    .panel > div:not(:last-child)
        margin-bottom: 15px

    .save
        margin-top: 30px
        i
          margin-right: 8px
          top: 2px
          position: relative

    @media screen and (min-width: 992px)
        .save
            margin-top: 0
</style>
